import { computed, Injectable, signal, WritableSignal } from '@angular/core';

export enum FilterTypeEnum {
    FIELD_INTERVENTION_ENTITIES = 'field-intervention-entities',
    MAP_ENTITIES = 'map-entities',
}

@Injectable({
    providedIn: 'root',
})
export abstract class FilterService<T> {
    public readonly currentFilter: WritableSignal<FilterTypeEnum | null> = signal(null);
    public readonly filterByParams: WritableSignal<T | undefined> = signal(undefined);
    public readonly filterElementsCount = computed(() => {
        if (!this.filterByParams() || !Object.keys(this.filterByParams()!).length) {
            return 0;
        }

        let count = 0;
        Object.values(this.filterByParams()!).forEach((param) => {
            if (Array.isArray(param)) {
                count += param.length;
            } else if (param) {
                count += 1;
            }
        });

        return count;
    });

    public initData(): void {}

    public reset(): void {
        this.resetCurrentFilter();
        this.resetFilterByParams();
    }

    public resetCurrentFilter(): void {
        this.currentFilter.set(null);
    }

    public resetFilterByParams(): void {
        this.filterByParams.set(undefined);
    }
}
